import * as yup from "yup";

export type TowerPaymentsPairFormValues = {
  pairCode: string;
  paymentMethodId: string;
};

export const schema = yup.object().shape({
  pairCode: yup.string().required(),
  paymentMethodId: yup.string().required(),
});
